<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Virology EMR Preview
    </template>
    <template #body>
      <b> {{ virologyList.length }} results found: </b> 
     
      <div class="sections">
        <div v-if="virologyList.length === 0">
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Result"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Code"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Date"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Time"
              />
            </div>
          </div>
        </div>
        <div
          v-for="( item, index ) in virologyList"
          :key="item"
        >
          <!-- <br> -->
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                v-model="item.sampleCode"
                disabled
                label="Code"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                v-model="item.testResult"
                disabled
                :label="`Test Result ${index + 1}`"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                v-model="item.testDate"
                disabled
                label="Test Date"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                v-model="item.testTime"
                disabled
                label="Test Time"
              />
            </div>
          </div>
          <hr class="lineBreak">
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import { RECIPIENT_VIROLOGY_LOIN_CODES, RECIPIENT_VIROLOGY_CODES_MAPPING, LIVING_DONOR_VIROLOGY_CODES_MAPPING } from "@/constants";

export default {
  name: "VirologySectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientType:{
      type: String,
      default: null
    },
  },
  data() {
    return {
      // testResult: this.getCMVIGGAB( this.patientBundle ),
      // testDate: this.getTestDate( this.patientBundle ),
      // sampleDate: this.getTestDate( this.patientBundle ),
      // sampleCode: this.getSampleCode( this.patientBundle ),
      virologyList: this.getVirologyList( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getVirologyList( patientBundle ) {
      const entries = _.get( patientBundle, 'entries', [] );
      if ( !Array.isArray( entries ) || entries.length === 0 ) return [];

      const observationGroups = entries.filter(
        ( n ) =>
          _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );

      const observations = observationGroups && observationGroups[0];
      if ( !Array.isArray( observations ) || observations.length === 0 ) return [];

      const config =
        this.patientType === 'Recipient'
          ? [
              { resultCode: 'UHN#3885', dateCode: 'UHN#3886', timeCode: 'UHN#3887', sampleCode: 'HTLV1' },
              { resultCode: 'UHN#3882', dateCode: 'UHN#3883', timeCode: 'UHN#3884', sampleCode: 'HIV_NAT' },
              { resultCode: 'UHN#3838', dateCode: 'UHN#3839', timeCode: 'UHN#3840', sampleCode: 'CMV_IGG_AB' },
              { resultCode: 'UHN#3855', dateCode: 'UHN#3856', timeCode: 'UHN#3857', sampleCode: 'EBV_CAPSID_AB' },
              { resultCode: 'UHN#3858', dateCode: 'UHN#3859', timeCode: 'UHN#3860', sampleCode: 'EBV_EARLY_AB' },
              { resultCode: 'UHN#3861', dateCode: 'UHN#3862', timeCode: 'UHN#3863', sampleCode: 'HBV_SURFACE_AG' },
              { resultCode: 'UHN#3864', dateCode: 'UHN#3865', timeCode: 'UHN#3866', sampleCode: 'HBV_CORE_AB' },
              { resultCode: 'UHN#3867', dateCode: 'UHN#3868', timeCode: 'UHN#3869', sampleCode: 'HBV_AB' },
              { resultCode: 'UHN#3870', dateCode: 'UHN#3871', timeCode: 'UHN#3872', sampleCode: 'HCV_AB' },
              { resultCode: 'UHN#3873', dateCode: 'UHN#3874', timeCode: 'UHN#3875', sampleCode: 'HBV_NAT' },
              { resultCode: 'UHN#3876', dateCode: 'UHN#3877', timeCode: 'UHN#3878', sampleCode: 'HCV_NAT' },
              { resultCode: 'UHN#3879', dateCode: 'UHN#3880', timeCode: 'UHN#3881', sampleCode: 'HIV' },
              { resultCode: 'UHN#3888', dateCode: 'UHN#3889', timeCode: 'UHN#3890', sampleCode: 'TOXOPLASMOSIS' },
              { resultCode: 'UHN#3891', dateCode: 'UHN#3892', timeCode: 'UHN#3893', sampleCode: 'Syphillis' },
              { resultCode: 'UHN#3894', dateCode: 'UHN#3895', timeCode: 'UHN#3896', sampleCode: 'VZV_AB' },
              { resultCode: 'UHN#3897', dateCode: 'UHN#3898', timeCode: 'UHN#3899', sampleCode: 'MEASLES_AB' },
              { resultCode: 'UHN#3900', dateCode: 'UHN#3901', timeCode: 'UHN#3902', sampleCode: 'MUMPS_AB' },
              { resultCode: 'UHN#3903', dateCode: 'UHN#3904', timeCode: 'UHN#3905', sampleCode: 'RUBELLA_AB' },
            ]
          : [
              { resultCode: 'UHN#3923', dateCode: 'UHN#3924', timeCode: 'UHN#3925', sampleCode: 'HIV_NAT' },
              { resultCode: 'UHN#3926', dateCode: 'UHN#3927', timeCode: 'UHN#3928', sampleCode: 'HCV_NAT' },
              { resultCode: 'UHN#3929', dateCode: 'UHN#3930', timeCode: 'UHN#3931', sampleCode: 'CMV_IGG_AB' },
              { resultCode: 'UHN#3932', dateCode: 'UHN#3933', timeCode: 'UHN#3934', sampleCode: 'HBV_CORE_AB' },
              { resultCode: 'UHN#3935', dateCode: 'UHN#3936', timeCode: 'UHN#3937', sampleCode: 'HBV_AB' },
              { resultCode: 'UHN#3938', dateCode: 'UHN#3939', timeCode: 'UHN#3940', sampleCode: 'HBV_SURFACE_AG' },
              { resultCode: 'UHN#3941', dateCode: 'UHN#3942', timeCode: 'UHN#3943', sampleCode: 'HCV_AB' },
              { resultCode: 'UHN#3944', dateCode: 'UHN#3945', timeCode: 'UHN#3946', sampleCode: 'HIV' },
              { resultCode: 'UHN#3947', dateCode: 'UHN#3948', timeCode: 'UHN#3949', sampleCode: 'HTLV1' },
              { resultCode: 'UHN#3950', dateCode: 'UHN#3951', timeCode: 'UHN#3952', sampleCode: 'Syphillis' },
              { resultCode: 'UHN#3953', dateCode: 'UHN#3954', timeCode: 'UHN#3955', sampleCode: 'EBV_CAPSID_AB' },
              { resultCode: 'UHN#3912', dateCode: 'UHN#3913', timeCode: 'UHN#3914', sampleCode: 'WEST_NILE_IGM' },
            ];

      const configByResultCode = new Map( config.map( ( c ) => [ c.resultCode, c ] ) );
      const dateCodesWanted = new Set( config.map( ( c ) => c.dateCode ) );
      const timeCodesWanted = new Set( config.map( ( c ) => c.timeCode ) );
      // Index test dates once (first match wins, same as prior `filter()[0]` behavior).
      const testDateByCode = Object.create( null );
      for ( const item of observations ) {
        const code = _.get( item, 'resource.code.coding[0].code' );
        if ( dateCodesWanted.has( code ) && testDateByCode[ code ] === undefined ) {
          testDateByCode[ code ] = _.get( item, 'resource.component[0].valueDateTime' );
        }
      }
      const testTimeByCode = Object.create( null );
      for ( const item of observations ) {
        const code = _.get( item, 'resource.code.coding[0].code' );
        if ( timeCodesWanted.has( code ) && testTimeByCode[ code ] === undefined ) {
          testTimeByCode[ code ] = _.get( item, 'resource.component[0].valueTime' );
        }
      }

      // Preserve original output ordering by iterating observations in-place.
      const virologyList = [];
      for ( const item of observations ) {
        const code = _.get( item, 'resource.code.coding[0].code' );
        const cfg = configByResultCode.get( code );
        if ( !cfg ) continue;

        virologyList.push( {
          testResult: _.get( item, 'resource.component[0].valueString', '' ),
          testDate: testDateByCode[ cfg.dateCode ],
          testTime: testTimeByCode[ cfg.timeCode ],
          sampleCode: cfg.sampleCode,
        } );
      }

      return virologyList;
    },
    getSampleCode( code ) {
      if( this.patientType === 'Recipient' )
      return RECIPIENT_VIROLOGY_CODES_MAPPING[ code ];
      else {
        return LIVING_DONOR_VIROLOGY_CODES_MAPPING[ code ]
      }
      
    }
  },
};
</script>

<style scoped>

.card {
  /* height: 100%; */
  /* height: 450px; */
}

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 450px;
  width: 1400px;
  overflow: scroll;
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayComments {
  border-style: solid;
  width: 650px;
  background-color: #F2F2F2;
}

.textArea
   {
  width: 650px;
  height: 50px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

.lineBreak {
  /* color: black;
  height: 2px; */
  background-color: rgb(59, 53, 53);
  border: 0 none;
    /* color: black; */
  height: 5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.comments .afflo-ds-form-control) {
  width: 500px;
}

</style>
